import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { NetzTranslateService } from '../../../services/netz-translate.service';

@Component({
  providers: [ConfirmationService],
  selector: 'section-comment',
  templateUrl: './section-comment.component.html',
  styleUrls: ['./section-comment.component.scss'],
})
export class SectionCommentComponent implements OnInit {
  @Input() isCommentTextInputVisible: boolean;
  @Input() isCommentTextVisible: boolean;
  @Input() isCommentSaveVisible: boolean;
  @Input() isCommentDeleteButtonDisabled: boolean;
  @Input() comment: string;
  @Input() formName: string;

  @Output() saveCommentEvent = new EventEmitter<{ section: string; value: string }>();
  @Output() deleteCommentEvent = new EventEmitter<string>();
  @Output() changeTextEvent = new EventEmitter<string>();

  private quill: any;
  private readonly MAX_COMMENT_LENGTH: number = 1000;

  constructor(private confirmationService: ConfirmationService, private translate: NetzTranslateService) {}
  ngOnInit(): void {}

  public saveComment(): void {
    if (this.quill.root.textContent) {
      this.comment = this.quill.root.innerHTML;
      this.isCommentSaveVisible = false;
      this.saveCommentEvent.emit({ section: this.formName, value: this.comment });
    }
  }

  public deleteComment(): void {
    this.isCommentSaveVisible = true;
    this.deleteCommentEvent.emit(this.formName);
    this.comment = null;
  }

  public confirm() {
    this.confirmationService.confirm({
      header: this.translate.translateString('grid-comp.comment.confirmation'),
      message: this.translate.translateString('grid-comp.comment.delete-confirmation'),
      accept: () => {
        this.deleteComment();
      },
    });
  }

  public textChanged($event) {
    if ($event.htmlValue?.length > this.MAX_COMMENT_LENGTH) {
      const exceedingChars = $event.htmlValue.length - this.MAX_COMMENT_LENGTH;
      this.quill.deleteText($event.textValue.length - exceedingChars, exceedingChars);
      this.comment = this.quill.root.innerHTML;
    }

    this.changeTextEvent.emit($event.textValue);
  }

  public editorOnInit(event: any) {
    this.quill = event.editor;
  }
}
